<p-table [value]="assignedUsers"
         styleClass="p-datatable-striped p-datatable-sm"
         [tableStyle]="{'min-width': '30rem'}">
    <ng-template pTemplate="header">
        <tr>
            <th>Nombre</th>
            <th style="max-width:10%" *ngIf="renderActions"><i class="pi pi-cog"></i> Operaciones</th>
            <th style="width:15%" *ngIf="renderKnobActions">Progreso evaluación</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user>
        <tr>
            <td>
                {{ user.nombreCompleto }}
                <p-tag styleClass="text-xs" *ngIf="user.rol!==null"
                       icon="pi pi-user" [value]="user.rol"/>
                <p-tag styleClass="text-xs" *ngIf="user.tipoUsuario!==null && renderKnobActions"
                       icon="pi pi-user" [value]="user.tipoUsuario"/>
            </td>
            <td class="flex align-items-center w-full" *ngIf="renderActions">
                <ng-container
                        *ngTemplateOutlet="confirmarCancelTemplate; context: {$implicit: user, clickEvent: onItemClicked.bind(this, user)}"></ng-container>
            </td>
            <td class="flex align-items-center" *ngIf="renderKnobActions">
                <ng-container *ngTemplateOutlet="progresoEvalTemplate; context: {$implicit: user}"></ng-container>
            </td>
        </tr>
    </ng-template>
</p-table>
